import {Component, EventEmitter, OnInit, Output} from '@angular/core';
import {BreadcrumbService} from "xng-breadcrumb";
import {ActivatedRoute, Router} from "@angular/router";
import {Globals} from "../globals";
import {AllService} from "./all.service";
import {environment} from "../../environments/environment";
import {FormControl, ReactiveFormsModule} from '@angular/forms';
import {MatSliderDragEvent} from "@angular/material/slider";

@Component({
  standalone: false,
  selector: 'app-all-child',
  imports: [ReactiveFormsModule],
  styleUrls: ['./all-child.css'],
  templateUrl: './all-child.component.html'
})
export class AllChildComponent implements OnInit {
  url: any;
  urls: any;
  itemsShop: any;
  itemsUrl: any;
  itemsShopList = [];
  urlList : any = [];
  environment: any;
  imageSrc: any;
  counties: any;
  itemsShopCopy: any;
  breadcrumb: any = [];
  breadcrumbs: any;
  finalBreadcrumb: any;
  in_itemsShop: any;
  home: string = 'home';
  category: string = 'category';
  subcategory: string = 'subcategory';
  selectedLocation = 'All';
  selectedCategory = 'All';
  selectedSubcategory = 'All';
  categories = [];
  subcategories = [];
  urlName: string = '';
  urlProfile: string = '';
  subUrlName: string = '';
  subSubUrlName: string = '';
  id: any;
  start = new FormControl();
  end = new FormControl();
  @Output()
  dragStart: EventEmitter<MatSliderDragEvent>
  @Output()
  dragEnd: EventEmitter<MatSliderDragEvent>


  constructor(private activatedRoute: ActivatedRoute,
              private router: Router,
              private breadcrumbService: BreadcrumbService,
              private allService: AllService,
              public globals: Globals) {
    environment.then(environment => {
      this.environment = environment;
      this.url = environment["backendURL"];
      this.imageSrc = environment["images"];
    });
  }

  private setBreadcrumb() {
    this.breadcrumbService.set('@all-motors', 'All Motors');
    this.breadcrumbService.set('@car', 'Car');
    this.breadcrumbService.set('@campervan', 'Camper-van');
    this.breadcrumbService.set('@motor-bike', 'Motor-bike');
    this.breadcrumbService.set('@Monitors', 'Monitors');
    this.breadcrumbService.set('@allMusics', 'All Music');
    this.breadcrumbService.set('@Laptops', 'Laptops');
    this.breadcrumbService.set('@Clothes', 'Clothes');
    this.breadcrumbService.set('@all-gaming', 'All Gaming');
    this.breadcrumbService.set('@consoles', 'Consoles');
    this.breadcrumbService.set('@allwomans', "All Women's");
    this.breadcrumbService.set('@allHousehold', "All Household");
    this.breadcrumbService.set('@kitchens', 'Kitchen');
    this.breadcrumbService.set('@bedrooms', 'Bedroom');
    this.breadcrumbService.set('@furnitures', 'Furniture & Interior');
    this.breadcrumbService.set('@AllSport', 'All Sport');
    this.breadcrumbService.set('@GymGears', 'Gym Gear');
    this.breadcrumbService.set('@GymEquipments', 'Gym Equipment');
    this.breadcrumbService.set('@all-food', 'Food');
    this.breadcrumbService.set('@AllSports', 'All Sport');
    this.breadcrumbService.set('@AllTickets', 'All Tickets');
    this.breadcrumbService.set('@sportevents', 'Sport Events');
    this.breadcrumbService.set('@concerts', 'Concerts');
    this.breadcrumbService.set('@festivals', 'Festivals');
    this.breadcrumbService.set('@allProperties', 'All Property');
    this.breadcrumbService.set('@propertyswaps', 'Property Swap');
    this.breadcrumbService.set('@rentals', 'Rental');
    this.breadcrumbService.set('@allTravels', 'All Travel');
    this.breadcrumbService.set('@weekendbreaks', 'Weekend Breaks');
    this.breadcrumbService.set('@holidays', 'Holidays');
    this.breadcrumbService.set('@all-electronics', 'All Electronics');
    this.breadcrumbService.set('@laptops', 'Laptops');
    this.breadcrumbService.set('@gaming-pcs', 'Gaming PCs');
    this.breadcrumbService.set('@pcs', 'PCs');
    this.breadcrumbService.set('@monitors', 'Monitors');
    this.breadcrumbService.set('@allsmartphones', 'All Smartphones');
    this.breadcrumbService.set('@androids', 'Android');
    this.breadcrumbService.set('@ioss', 'iOS');
    this.breadcrumbService.set('@all-gamings', 'All Gaming');
    this.breadcrumbService.set('@consoles', 'Consoles');
    this.breadcrumbService.set('@games', 'Games');
    this.breadcrumbService.set('@records', 'Records');
    this.breadcrumbService.set('@instruments', 'Instrument');
    this.breadcrumbService.set('@radios', 'Radios');
    this.breadcrumbService.set('@jewellerys', 'Jewellery');
    this.breadcrumbService.set('@clothes', 'Clothes');
    this.breadcrumbService.set('@shoes', 'Shoes');
    this.breadcrumbService.set('@makeups', 'Makeup');
  }

  ngOnInit(): void {
    this.id = this.activatedRoute.snapshot.paramMap.get('id');
    // console.log('allCHildCOmponent', this.id, this.url);
    this.setBreadcrumb();

    this.urls = this.router.url.split('/').filter(element => element);
    console.log('url', this.urls);

    let endpoint = '';
    if (this.urls.length == 3) {
      this.urlName = this.urls[1];
      this.subUrlName = this.urls[0];
      endpoint = this.urls[1].replace('all-', '');
      if (!endpoint.includes('-and-')) {
        endpoint = endpoint.replace('-', ' ');
      }
    }
    if (this.urls.length == 4) {
      this.urlProfile = this.urls[0];
      this.urlName = this.urls[2];
      this.subUrlName = this.urls[1];
      endpoint = this.urls[2].replace('all-', '');
      if (!endpoint.includes('-and-')) {
        endpoint = endpoint.replace('-', ' ');
      }
    }
    if (this.urls.length == 5) {
      this.urlProfile = this.urls[0];
      this.subUrlName = this.urls[1];
      this.urlName = this.urls[2];
      this.subSubUrlName = this.urls[3];
      endpoint = this.urls[2].replace('all-', '');
      if (!endpoint.includes('-and-')) {
        endpoint = endpoint.replace('-', ' ');
      }
    }
    // console.log('test', this.urls, 'test1', this.urlName, 'test2', this.subUrlName, 'test3', endpoint, 'test4', this.urlProfile);
    if (this.urls.length === 3) {
      this.sortUrlLengthThree(endpoint);
    } else {
      this.sortUrlLengthFour(endpoint);
    }
    this.sortSideBar();
    this.allService.getCounties(this.url, '/counties')
      .subscribe(response => {
        this.counties = response;
        this.counties.push({locationId: 33, name: 'All', province: 'All'});
        this.counties.sort((a, b) => a.name.localeCompare(b.name));
      });
  }

  private sortUrlLengthThree(endpoint: string) {
    if (this.urls[1].includes('all-')) {
      this.getAllItem(this.urls, endpoint);
    } else {
      this.getAllItemBySubCategory(this.urls, endpoint);
    }
  }

  private sortUrlLengthFour(endpoint: string) {
    if (this.urls[2].includes('all-')) {
      this.getAllItemsByProfile(endpoint);
    } else {
      this.getAllSubCategoryProfile(endpoint);
    }
  }

  private getAllItemBySubCategory(urls: string[], endpoint: string) {
    this.allService.getSearchCategories(this.url, this.getCateoryUrl(urls[0]), this.getCateoryUrl(endpoint))
      .subscribe(response => {
        this.itemsShop = response;
        this.sortItemShopList();
      });
  }

  private getAllSubCategoryProfile(endpoint: string) {
    console.log('yeah', this.url, this.getCateoryUrl(this.urls[1]), this.getCateoryUrl(endpoint), this.urlProfile);
    this.allService.getSearchCategoriesProfile(this.url, this.getCateoryUrl(this.urls[1]), this.getCateoryUrl(endpoint), this.urlProfile)
      .subscribe(response => {
        this.itemsShop = response;
        this.sortItemShopList();
      });
  }

  private sortItemShopList() {
    this.itemsShop.forEach(
      item => {
        this.sortItemImages(item, this.url, this.imageSrc);
        if (this.globals.location === item.locationId.name || this.globals.location === 'All') {
          this.itemsShopList.push(item)
        }
      });
    this.itemsShopList.sort((a, b) => a.categoryId.subcategoryId.name.localeCompare(b.categoryId.subcategoryId.name));
  }

  private getAllItem(urls: string[], endpoint: string) {
    // console.log('if', urls[1]);
    this.allService.getAllByItem(this.url + '/' + endpoint)
      .subscribe(response => {
        this.itemsShop = response;
        this.sortItemShopList();
      });
  }

  private getAllItemsByProfile(endpoint: string) {
    this.allService.getItems(this.url + '/' + endpoint, this.urlProfile)
      .subscribe(response => {
        this.itemsShop = response;
        this.sortItemShopList();
      });
  }

  private sortItemImages(item, url, imgStr) {
    let photosTemp = item.photo.split(";");
    if (photosTemp) {
      item.photo = imgStr + photosTemp[0];
    } else {
      item.photo = imgStr + item.photo
    }
  }

  onSelected(value: any): void {
    this.globals.location = value.value;
    this.itemsShopList = [];
    this.itemsShop.forEach(
      item => {
        if (item.locationId.name === this.globals.location || this.globals.location === 'All') {
          this.itemsShopList.push(item)
        }
      });
    this.itemsShopList.sort((a, b) => a.categoryId.subcategoryId.name.localeCompare(b.categoryId.subcategoryId.name));
  }

  showAsList() {
    this.globals.isPanel = false;
    this.globals.isList = true;
  }

  showAsPanel() {
    this.globals.isList = false;
    this.globals.isPanel = true;
  }

  moreFilters() {
    this.globals.selectedFilter = !this.globals.selectedFilter;
  }

  private sortSideBar() {
    this.urlList = [];
    let profile = 'null';
    if (this.globals.listingFilter.profile) {
      profile = this.globals.listingFilter.profile;
    }
    this.allService.getItems(this.url + '/' + this.subUrlName, profile).subscribe(response => {
      this.urlList = response;
    });
  }

  private getCategory(item) {
    if (item.categoryId.name.includes(' and ')) {
      return item.categoryId.name.replace(' and ', '-and-');
    }
    return item.categoryId.name;
  }

  private getAllSubcategory(category: string) {
    console.log(category, category);
    return 'all-' + category.replace(' & ', '-and-');
  }

  private getCateoryUrl(url: string) {
    if (url.includes('-and-')) {
      return url.replace('-and-', ' & ');
    }
    return url;
  }

  onDragStartA(e: MatSliderDragEvent) {
    console.log('onDragStartA: ', e.value);
  }

  onDragEndA(e: MatSliderDragEvent) {
    console.log('onDragEndA: ', e.value);
  }

  onValueChangeA(e: number) {
    console.log('onValueChangeA:', e);
  }

  onDragStartB(e: MatSliderDragEvent) {
    console.log('onDragStartB: ', e.value);
  }

  onDragEndB(e: MatSliderDragEvent) {
    console.log('onDragEndB: ', e.value);
  }

  onValueChangeB(e: number) {
    console.log('onValueChangeB:', e);
  }
}
